import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { apiService } from "../../services";
import DocumentsPage from "../../components/DocumentsPage";

const Documents = () => {
  let { id } = useParams();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState(undefined);

  useEffect(() => {
    if (!!id) {
      apiService.getDocumentSignedUrl(id)
        .then((signedUrl) => {
          const link = document.createElement('a');
          link.href = signedUrl;
          link.download = id;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => setError(error))
        .finally(() => setIsLoading(false))
    }
  }, [id]);

  return <DocumentsPage isLoading={isLoading} error={error} />;
};

export default Documents;
